import React from 'react'
import {Icon} from '@chakra-ui/react'

const CareShieldIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M16.6668 10.8333C16.6668 15 13.7502 17.0833 10.2835 18.2917C10.102 18.3532 9.90478 18.3502 9.72516 18.2833C6.25016 17.0833 3.3335 15 3.3335 10.8333V5C3.3335 4.77898 3.42129 4.56702 3.57757 4.41074C3.73385 4.25446 3.94582 4.16667 4.16683 4.16667C5.8335 4.16667 7.91683 3.16666 9.36683 1.9C9.54338 1.74916 9.76796 1.66629 10.0002 1.66629C10.2324 1.66629 10.457 1.74916 10.6335 1.9C12.0918 3.175 14.1668 4.16667 15.8335 4.16667C16.0545 4.16667 16.2665 4.25446 16.4228 4.41074C16.579 4.56702 16.6668 4.77898 16.6668 5V10.8333Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.5 17.5L7.5 3.75" stroke="currentColor" strokeWidth="1.5" opacity="0.1" />
            <path d="M12.5 17.5L12.5 3.75" stroke="currentColor" strokeWidth="1.5" opacity="0.1" />
            <path
                d="M7.5 9.99999L9.16667 11.6667L12.5 8.33333"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default CareShieldIcon
